import { ModuleWithProviders, NgModule } from '@angular/core';
import { AlertComponent } from './components/alert/alert.component';
import { AlertService } from './services/alert.service';
import { CommonModule } from '@angular/common';
import { ChassisModalModule } from '../modals/modals.module';

@NgModule({
    imports: [
        ChassisModalModule,
        CommonModule,
    ],
    declarations: [
        AlertComponent
    ],
    entryComponents: [
        AlertComponent
    ],
    providers: [
        AlertService
    ],
    exports: [
        AlertComponent,
    ],
})
export class ChassisAlertModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ChassisAlertModule,
            providers: [
                AlertService
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/alerts/alert.module.ts